import React from 'react';
import styled from 'styled-components/macro';
import {
  HeaderMenuItemId,
  HeaderMenuItemRegister,
  HeaderMenuItemVisibilityChecker,
} from './helpers/useHeaderMenuItemVisibility';

type Props = {
  children: React.ReactNode;
  isVisible: HeaderMenuItemVisibilityChecker;
  itemId: HeaderMenuItemId;
  registerItem: HeaderMenuItemRegister;
};

export const MenuItemSlot = (props: Props) => {
  const { children, isVisible, itemId, registerItem } = props;

  if (!isVisible(itemId)) {
    return null;
  }

  return <MenuItemSlotWrapper ref={registerItem(itemId)}>{children}</MenuItemSlotWrapper>;
};

const MenuItemSlotWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  min-height: var(--header-row-height);
  align-self: stretch;
`;
